class MediaGallery extends HTMLElement {
  images;
  constructor() {
    super();
    this.images = this.querySelectorAll('img');
    this.svgIcon = this.querySelector('& > button svg');
    this.parentGrid = this.closest('[pdp-layout]');
    this.links = this.querySelectorAll('a');

    document.addEventListener('keydown', (ev) => {
      if (this.contains(document.activeElement) && ev.code === 'Escape') {
        this.contractGalleryView(ev);
      }
    });

    this.links.forEach((link) => {
      link.addEventListener('click', (ev) => {
        if (window.innerWidth <= 767) return;
        ev.preventDefault();
        let isExpanded = this.parentGrid.children[0].classList.contains('lg:col-span-12');

        if (isExpanded) {
          this.contractGalleryView(ev);
        } else {
          this.expandGalleryView(ev);
        }
      });
    });

    // I hate this but the sticky button just doesn't work without it
    const updateScrollAmount = function () {
      // To avoid having the product image in magnified mode close button moved we should
      // use 60 + <dynamic_value> determined whether the promo_bar has the hidden class attached or not.
      const promoBar = document.querySelector('promo-bar');
      let scrollAmount = Math.max(0, 60 - document.documentElement.scrollTop);
      scrollAmount += promoBar ? promoBar.clientHeight : 0;
      document.documentElement.style.setProperty('--gallery-scroll-offset', `${scrollAmount}px`);
    };

    window.addEventListener('scroll', (ev) => {
      updateScrollAmount();
    });
    updateScrollAmount();
  }

  expandGalleryView(ev) {
    this.parentGrid.children[0].classList.remove('lg:col-span-7', 'md:col-span-6');
    this.parentGrid.children[0].classList.add('lg:col-span-12', 'md:col-span-12');
    this.parentGrid.children[1].classList.add('hidden');
    this.svgIcon.querySelector('[data-close-icon]').classList.remove('hidden');
    this.useAltSizes();

    let parentUl = ev.target.closest('ul');
    parentUl.querySelectorAll('li svg').forEach((svg) => svg.classList.add('hidden'));
    let parentLi = ev.target.closest('li');
    if (parentLi.index === 0) {
      document.documentElement.scrollTop = 0;
    } else {
      parentLi.scrollIntoView();
    }
  }

  contractGalleryView(ev) {
    this.parentGrid.children[0].classList.add('lg:col-span-7', 'md:col-span-6');
    this.parentGrid.children[0].classList.remove('lg:col-span-12', 'md:col-span-12');
    this.parentGrid.children[1].classList.remove('hidden');
    this.svgIcon.querySelector('[data-close-icon]').classList.add('hidden');
    this.useDefaultSizes();

    let parentUl = ev.target.closest('ul');
    parentUl.querySelectorAll('li svg').forEach((svg) => svg.classList.remove('hidden'));
    let parentLi = ev.target.closest('li');
    if (parentLi.index === 0) {
      document.documentElement.scrollTop = 0;
    } else {
      parentLi.scrollIntoView();
    }
  }

  useDefaultSizes() {
    this.images.forEach((image) => {
      if (!image.hasAttribute('data-default-sizes')) {
        image.setAttribute('data-default-sizes', image.getAttribute('sizes'));
      }
      image.setAttribute('sizes', image.dataset.defaultSizes);
    });
  }

  useAltSizes() {
    this.images.forEach((image) => {
      image.setAttribute('sizes', image.dataset.altSizes);
    });
  }
}

customElements.define('media-gallery', MediaGallery);
